import { PaymentMethodType } from '@/types/boot';
import { PaymentMethodEnum } from '@/types/common';

export const PaymentMethodTypeToEnum: Record<PaymentMethodType, PaymentMethodEnum> = {
  [PaymentMethodType.CREDIT_CARD]: PaymentMethodEnum.CREDIT_CARD,
  [PaymentMethodType.PAYPAL]: PaymentMethodEnum.PAYPAL,
  [PaymentMethodType.APPLE_PAY]: PaymentMethodEnum.APPLE_PAY,
  [PaymentMethodType.GOOGLE_PAY]: PaymentMethodEnum.GOOGLE_PAY,
};
